import React, { useState } from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import LinkWithChevron from '@ilg-totallymoney/ui/components/LinkWithChevron'
import Modal from '@ilg-totallymoney/ui/components/Modal'
import Text from '@ilg-totallymoney/ui/components/Text'
import PreApprovedBadge from '@ilg-totallymoney/ui/productTable/components/PreApprovedBadge'

import { whatIsPreapprovedFaqUrl } from '@constants/helpLinks'

const PreApprovedBadgeWithModal = () => {
    const [isModalOpen, setModalOpen] = useState(false)

    return (
        <>
            <PreApprovedBadge
                accessibilityLabel="Show pre-approval details"
                onClick={() => setModalOpen(true)}
            />
            {isModalOpen && (
                <Modal
                    isOpen={isModalOpen}
                    onClose={() => setModalOpen(false)}
                    title="What does ‘Pre-approved’ mean?"
                    hasHeader={false}
                    hasTooltipHeader={true}
                    isFullScreen={true}
                    hasMinHeight={false}
                >
                    <Box ml="space05">
                        <Box mb="space15">
                            <Text>
                                Pre-approval is subject to credit checks. If you
                                apply, you’ll get the card or loan, at the rate
                                advertised, providing the information you give
                                us is accurate and you pass the lender’s final
                                checks.
                            </Text>
                        </Box>

                        <LinkWithChevron
                            href={whatIsPreapprovedFaqUrl}
                            variant="100"
                            target="_blank"
                        >
                            Find out more here
                        </LinkWithChevron>
                    </Box>
                </Modal>
            )}
        </>
    )
}

export default PreApprovedBadgeWithModal
